import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum'; 
//import { AbsenceLeave} from '../entities/absence-leave'; 
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators';
import { ExecutingUnit } from '../entities/executingUnit';
//import { EmployeeTtype } from '../entities/employeeTtype';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Hhelpdesk } from '../entities/hhelpdesk';
//import { Absence } from '../entities/absence';
import { CostCenter } from '../entities/costCenter';
import { Employee } from '../entities/employee';
import { FiscalYear } from '../entities/fiscalYear';
import { PayrollType } from '../entities/payroll-type';
import { EmployeeType } from '../entities/employeeType';
import { ReportAlphabetical } from '../model/report-alphabetical';
import { FundingSource } from '../entities/funding-source';
import { ProgrammaticStructure } from '../entities/programmaticStructure';

interface ExtraSearchFields { 
 //obligatorios
  fiscalYear?: FiscalYear,
  executingUnit?: ExecutingUnit, 
  month?: Hhelpdesk,
  payrollType?: PayrollType,
  employeeType?: EmployeeType, 
}

@Injectable()
export class ReportSummaryConceptService extends BaseReportService<ReportAlphabetical> {

  public uri = '/api/reportSummaryConcept/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance ReportAbsenceDetailService');
  }
  
  buildSentence(entity?: ReportAlphabetical, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      
      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );  
      //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  } 
  
  
    searchToReport(entity?: ReportAlphabetical, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<ReportAlphabetical>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<ReportAlphabetical>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          }
          //console.log('response search check here');
          //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }
  
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-summary-concept.service.ts